
import { defineComponent } from "vue";
import layout from "@/components/container.vue";

export default defineComponent({
  name: "App",
  components: { layout },
});
